import e from "linkify-it";
//#region src/extensions/link-extension/utils/linkify-text.ts
var t = new e();
function n(e) {
	let n = t.match(e);
	if (!n) return {
		type: "doc",
		content: [{
			type: "paragraph",
			content: [{
				type: "text",
				text: e
			}]
		}]
	};
	let r = [], i = 0;
	for (let t of n) t.index > i && r.push({
		type: "text",
		text: e.slice(i, t.index)
	}), r.push({
		type: "text",
		text: t.raw,
		marks: [{
			type: "link",
			attrs: { href: t.url }
		}]
	}), i = t.lastIndex;
	return i < e.length && r.push({
		type: "text",
		text: e.slice(i)
	}), {
		type: "doc",
		content: r
	};
}
//#endregion
export { n as linkifyPlainText };
